import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'koncierz_cookie_consent';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const raw = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw);
      if (!parsed?.preferences?.analytics) return;
    } catch (err) {
      console.error('Invalid cookie consent value', err);
      return;
    }

    // Google Analytics 4
    if (window.gtag) {
      window.gtag('config', 'GA_MEASUREMENT_ID', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default Analytics;